import React, { useState, Component } from "react";
import styled from "styled-components";

import AvgFee from "./nav/avg_fee.js";
import TrafficFlow from "./nav/traffic_flow.js";
import VehicleNum from "./nav/vehicle_num.js";

const TabContentsWrapper = styled.div`
  position: relative;
  width: 100%;

  left: 0px;

  display: flex;
  flex-direction: column;

  align-items: center;
  justify-content: center;
`;

const tabTitle = [
  "내 주차장 주변 교통 유입량",
  "내 주차장 주변 평균 주차요금",
  "내 주차장 주변 지역 차량등록현황",
];
const tab = {
  0: <TrafficFlow />,
  1: <AvgFee />,
  2: <VehicleNum />,
};

export default class TabContents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: this.props.activeTab,
    };
  }

  render() {
    return (
      <TabContentsWrapper>
        <Nav>
          <List>
            {tabTitle.map((str, idx) => {
              return (
                <Tab
                  active={this.props.activeTab === idx}
                  key={idx}
                  onClick={() => this.props.menuTabHandler(idx)}
                >
                  <TabTitle active={this.props.activeTab === idx}>{str}</TabTitle>
                </Tab>
              );
            })}
          </List>
        </Nav>
        {tab[this.props.activeTab]}
      </TabContentsWrapper>
    );
  }
}

const Nav = styled.div`
  display: flex;
  justify-content: center;
`;

const List = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 80px;
  margin: 17px 17px 0 17px;
  font-size: 20px;
  color: #010101;
`;

const Tab = styled.div`
  height: 80px;
  width: 410px;
  cursor: pointer;
  background: ${(props) => (props.active ? "#F5F5F6" : "none")};

  display: flex;
  justify-content: center;
  align-items: center;
  border-radius : 20px 20px 0px 0px;

  & + & {
    margin-left: 30px;
  }
`;

const TabTitle = styled.div`
font-family: Noto Sans KR;
font-weight: ${(props) => (props.active ? "bold" : "normal")};
color: ${(props) => (props.active ? "#EF8A57" : "#8F8F8F")};
border-bottom: ${(props) => (props.active ? "3px solid #EF8A57" : "none")};
`;